/** Pure screening-cost maths shared by the calculator UI, its page and crawler copy. */
export type ScreeningInputs = { roles: number; applications: number; minutes: number; rate: number };
export type Currency = 'USD' | 'GBP' | 'EUR';

export const DEFAULT_INPUTS: ScreeningInputs = { roles: 6, applications: 250, minutes: 3, rate: 35 };
export const WORKDAY_HOURS = 7.5;
export const PRO_ANNUAL_MONTHLY_USD = 179;
export const SYMBOL: Record<Currency, string> = { USD: '$', GBP: '£', EUR: '€' };

export const LIMITS = {
  roles: { min: 1, max: 40, step: 1 },
  applications: { min: 20, max: 1000, step: 10 },
  minutes: { min: 1, max: 10, step: 0.5 },
  rate: { min: 15, max: 120, step: 1 },
} as const;

/** Monthly first-pass screening load from the four inputs. */
export function calculateScreeningCost({ roles, applications, minutes, rate }: ScreeningInputs) {
  const total = roles * applications;
  const hours = (total * minutes) / 60;
  return { total, hours, days: hours / WORKDAY_HOURS, cost: hours * rate };
}

export const formatMoney = (n: number, currency: Currency = 'USD') => `${SYMBOL[currency]}${Math.round(n).toLocaleString('en-US')}`;

export function clamp(key: keyof ScreeningInputs, raw: string | null): number | undefined {
  if (raw === null) return undefined;
  const n = Number(raw);
  if (!Number.isFinite(n)) return undefined;
  const { min, max, step } = LIMITS[key];
  return Math.min(max, Math.max(min, Math.round(n / step) * step));
}
